/* eslint-disable camelcase */
const viewCart = (_state, { amendingOrder, estimatedTotalCost, products }) => ({
  event: 'view_cart',
  ecommerce: {
    cart: {
      actionField: {
        option: amendingOrder ? 'amend' : 'purchase',
        value: estimatedTotalCost,
      },
      products: products.map(
        ({ id, price, quantity, offer, favourite, amendment_quantity_delta }) => ({
          id,
          price,
          quantity,
          offer,
          favourite,
          amendment_quantity_delta,
        }),
      ),
    },
  },
});

export default viewCart;
